import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';

import PaginationContext from './PaginationContext';


class NextButton extends PureComponent {
  render() {
    const { render: View } = this.props;
    const { scrollNext, nextChild } = this.context;


    return (
      <Fragment>
        {
          nextChild && <View scrollNext={ scrollNext }/>
        }
      </Fragment>
    );
  }
}


NextButton.propTypes = {
  render: PropTypes.func.isRequired
};
NextButton.contextType = PaginationContext;


export default NextButton;
